import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperSocialGroupJoinPage } from './shopper-social-group-join';

@NgModule({
  declarations: [
    ShopperSocialGroupJoinPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperSocialGroupJoinPage),
    TranslateModule.forChild()
  ],
})
export class ShopperSocialGroupJoinPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-join/shopper-social-group-join.module.ts